
var __extends = this.__extends || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    __.prototype = b.prototype;
    d.prototype = new __();
};
define('backend/dropbox',["require", "exports", '../generic/preload_file', '../core/file_system', '../core/node_fs_stats', '../core/buffer', '../core/api_error', '../core/node_path', '../core/browserfs', '../core/buffer_core_arraybuffer', "../../vendor/async/lib/async"], function(require, exports, preload_file, file_system, node_fs_stats, buffer, api_error, node_path, browserfs, buffer_core_arraybuffer) {
    var Buffer = buffer.Buffer;
    var Stats = node_fs_stats.Stats;
    var ApiError = api_error.ApiError;
    var ErrorCode = api_error.ErrorCode;
    var path = node_path.path;
    var FileType = node_fs_stats.FileType;

    window['db'] = window['Dropbox'];

    var async = require('../../vendor/async/lib/async');
    var Buffer = buffer.Buffer;

    var DropboxFile = (function (_super) {
        __extends(DropboxFile, _super);
        function DropboxFile(_fs, _path, _flag, _stat, contents) {
            _super.call(this, _fs, _path, _flag, _stat, contents);
        }
        DropboxFile.prototype.sync = function (cb) {
            var buffer = this._buffer;

            var backing_mem = this._buffer.getBufferCore();
            if (!(backing_mem instanceof buffer_core_arraybuffer.BufferCoreArrayBuffer)) {
                buffer = new Buffer(this._buffer.length);
                this._buffer.copy(buffer);
                backing_mem = buffer.getBufferCore();
            }

            var dv = backing_mem.getDataView();

            var abv = new DataView(dv.buffer, dv.byteOffset + buffer.getOffset(), buffer.length);
            this._fs._writeFileStrict(this._path, abv, cb);
        };

        DropboxFile.prototype.close = function (cb) {
            this.sync(cb);
        };
        return DropboxFile;
    })(preload_file.PreloadFile);
    exports.DropboxFile = DropboxFile;

    var Dropbox = (function (_super) {
        __extends(Dropbox, _super);
        function Dropbox(client) {
            _super.call(this);
            this.client = client;
        }
        Dropbox.prototype.getName = function () {
            return 'Dropbox';
        };

        Dropbox.isAvailable = function () {
            return typeof db !== 'undefined';
        };

        Dropbox.prototype.isReadOnly = function () {
            return false;
        };

        Dropbox.prototype.supportsSymlinks = function () {
            return false;
        };

        Dropbox.prototype.supportsProps = function () {
            return false;
        };

        Dropbox.prototype.supportsSynch = function () {
            return false;
        };

        Dropbox.prototype.empty = function (main_cb) {
            var self = this;
            self.client.readdir('/', function (error, paths, dir, files) {
                if (error) {
                    main_cb(self.convert(error));
                } else {
                    var deleteFile = function (file, cb) {
                        self.client.remove(file.path, function (err, stat) {
                            cb(err ? self.convert(err) : err);
                        });
                    };
                    var finished = function (err) {
                        if (err) {
                            main_cb(self.convert(err));
                        } else {
                            main_cb();
                        }
                    };
                    async.each(files, deleteFile, finished);
                }
            });
        };

        Dropbox.prototype.rename = function (oldPath, newPath, cb) {
            var self = this;
            self.client.move(oldPath, newPath, function (error, stat) {
                if (error) {
                    var missingPath = error.response.error.indexOf(oldPath) > -1 ? oldPath : newPath;
                    cb(new ApiError(1 /* ENOENT */, missingPath + " doesn't exist"));
                } else {
                    cb();
                }
            });
        };

        Dropbox.prototype.stat = function (path, isLstat, cb) {
            var self = this;

            self.client.stat(path, function (error, stat) {
                if (error || ((stat != null) && stat.isRemoved)) {
                    cb(new ApiError(1 /* ENOENT */, path + " doesn't exist"));
                } else {
                    var stats = new Stats(self._statType(stat), stat.size);
                    return cb(null, stats);
                }
            });
        };

        Dropbox.prototype.open = function (path, flags, mode, cb) {
            var self = this, _this = this;

            self.client.readFile(path, {
                arrayBuffer: true
            }, function (error, content, db_stat, range) {
                if (error) {
                    if (flags.isReadable()) {
                        cb(new ApiError(1 /* ENOENT */, path + " doesn't exist"));
                    } else {
                        switch (error.status) {
                            case 0:
                                return console.error('No connection');

                            case 404:
                                var ab = new ArrayBuffer(0);
                                return self._writeFileStrict(path, ab, function (error2, stat) {
                                    if (error2) {
                                        cb(error2);
                                    } else {
                                        var file = self._makeFile(path, flags, stat, new Buffer(ab));
                                        cb(null, file);
                                    }
                                });
                            default:
                                return console.log("Unhandled error: " + error);
                        }
                    }
                } else {
                    var buffer;

                    if (content === null) {
                        buffer = new Buffer(0);
                    } else {
                        buffer = new Buffer(content);
                    }
                    var file = self._makeFile(path, flags, db_stat, buffer);
                    return cb(null, file);
                }
            });
        };

        Dropbox.prototype._writeFileStrict = function (p, data, cb) {
            var self = this;
            var parent = path.dirname(p);
            self.stat(parent, false, function (error, stat) {
                if (error) {
                    cb(new ApiError(1 /* ENOENT */, "Can't create " + p + " because " + parent + " doesn't exist"));
                } else {
                    self.client.writeFile(p, data, function (error2, stat) {
                        if (error2) {
                            cb(self.convert(error2));
                        } else {
                            cb(null, stat);
                        }
                    });
                }
            });
        };

        Dropbox.prototype._statType = function (stat) {
            return stat.isFile ? 32768 /* FILE */ : 16384 /* DIRECTORY */;
        };

        Dropbox.prototype._makeFile = function (path, flag, stat, buffer) {
            var type = this._statType(stat);
            var stats = new Stats(type, stat.size);
            return new DropboxFile(this, path, flag, stats, buffer);
        };

        Dropbox.prototype._remove = function (path, cb, isFile) {
            var self = this;
            self.client.stat(path, function (error, stat) {
                var message = null;
                if (error) {
                    cb(new ApiError(1 /* ENOENT */, path + " doesn't exist"));
                } else {
                    if (stat.isFile && !isFile) {
                        cb(new ApiError(7 /* ENOTDIR */, path + " is a file."));
                    } else if (!stat.isFile && isFile) {
                        cb(new ApiError(8 /* EISDIR */, path + " is a directory."));
                    } else {
                        self.client.remove(path, function (error, stat) {
                            if (error) {
                                cb(new ApiError(2 /* EIO */, "Failed to remove " + path));
                            } else {
                                cb(null);
                            }
                        });
                    }
                }
            });
        };

        Dropbox.prototype.unlink = function (path, cb) {
            this._remove(path, cb, true);
        };

        Dropbox.prototype.rmdir = function (path, cb) {
            this._remove(path, cb, false);
        };

        Dropbox.prototype.mkdir = function (p, mode, cb) {
            var self = this;
            var parent = path.dirname(p);
            self.client.stat(parent, function (error, stat) {
                if (error) {
                    cb(new ApiError(1 /* ENOENT */, "Can't create " + p + " because " + parent + " doesn't exist"));
                } else {
                    self.client.mkdir(p, function (error, stat) {
                        if (error) {
                            cb(new ApiError(6 /* EEXIST */, p + " already exists"));
                        } else {
                            cb(null);
                        }
                    });
                }
            });
        };

        Dropbox.prototype.readdir = function (path, cb) {
            var self = this;
            this.client.readdir(path, function (error, files, dir_stat, content_stats) {
                if (error) {
                    return cb(self.convert(error));
                } else {
                    return cb(null, files);
                }
            });
        };

        Dropbox.prototype.convert = function (err, message) {
            if (typeof message === "undefined") { message = ""; }
            switch (err.status) {
                case 400:
                    return new ApiError(9 /* EINVAL */, message);
                case 401:

                case 403:
                    return new ApiError(2 /* EIO */, message);
                case 404:
                    return new ApiError(1 /* ENOENT */, message);
                case 405:
                    return new ApiError(14 /* ENOTSUP */, message);

                case 0:

                case 304:

                case 406:

                case 409:

                default:
                    return new ApiError(2 /* EIO */, message);
            }
        };
        return Dropbox;
    })(file_system.BaseFileSystem);
    exports.Dropbox = Dropbox;

    browserfs.registerFileSystem('Dropbox', Dropbox);
});
//# sourceMappingURL=dropbox.js.map
;